// extracted by mini-css-extract-plugin
module.exports = {"centered":"CenteredContentWrapper_centered__n7RwV"};